/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendVentureFundLoanDto } from '../models/backend-venture-fund-loan-dto';
import { ventureFundsVentureFundLoansCopyCreate } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-copy-create';
import { VentureFundsVentureFundLoansCopyCreate$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-copy-create';
import { ventureFundsVentureFundLoansCreate } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-create';
import { ventureFundsVentureFundLoansCreate$FormData } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-create-form-data';
import { VentureFundsVentureFundLoansCreate$FormData$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-create-form-data';
import { VentureFundsVentureFundLoansCreate$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-create';
import { ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-create-x-www-form-urlencoded';
import { VentureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-create-x-www-form-urlencoded';
import { ventureFundsVentureFundLoansDestroy } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-destroy';
import { VentureFundsVentureFundLoansDestroy$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-destroy';
import { ventureFundsVentureFundLoansPartialUpdate } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-partial-update';
import { ventureFundsVentureFundLoansPartialUpdate$FormData } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-partial-update-form-data';
import { VentureFundsVentureFundLoansPartialUpdate$FormData$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-partial-update-form-data';
import { VentureFundsVentureFundLoansPartialUpdate$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-partial-update';
import { ventureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-partial-update-x-www-form-urlencoded';
import { VentureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-partial-update-x-www-form-urlencoded';
import { ventureFundsVentureFundLoansUpdate } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-update';
import { ventureFundsVentureFundLoansUpdate$FormData } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-update-form-data';
import { VentureFundsVentureFundLoansUpdate$FormData$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-update-form-data';
import { VentureFundsVentureFundLoansUpdate$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-update';
import { ventureFundsVentureFundLoansUpdate$XWwwFormUrlencoded } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-update-x-www-form-urlencoded';
import { VentureFundsVentureFundLoansUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-loans/venture-funds-venture-fund-loans-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiVentureFundLoansService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ventureFundsVentureFundLoansCreate()` */
  static readonly VentureFundsVentureFundLoansCreatePath = '/api/venture_funds/venture-fund-loans/';

  /**
   * Создать займ венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundLoansCreate$Response(
    params: VentureFundsVentureFundLoansCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать займ венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundLoansCreate(
    params: VentureFundsVentureFundLoansCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /**
   * Создать займ венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать займ венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /**
   * Создать займ венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundLoansCreate$FormData$Response(
    params: VentureFundsVentureFundLoansCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать займ венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundLoansCreate$FormData(
    params: VentureFundsVentureFundLoansCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundLoansUpdate()` */
  static readonly VentureFundsVentureFundLoansUpdatePath = '/api/venture_funds/venture-fund-loans/{id}/';

  /**
   * Обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundLoansUpdate$Response(
    params: VentureFundsVentureFundLoansUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundLoansUpdate(
    params: VentureFundsVentureFundLoansUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /**
   * Обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundLoansUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundLoansUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundLoansUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundLoansUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /**
   * Обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundLoansUpdate$FormData$Response(
    params: VentureFundsVentureFundLoansUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundLoansUpdate$FormData(
    params: VentureFundsVentureFundLoansUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundLoansDestroy()` */
  static readonly VentureFundsVentureFundLoansDestroyPath = '/api/venture_funds/venture-fund-loans/{id}/';

  /**
   * Удалить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundLoansDestroy$Response(
    params: VentureFundsVentureFundLoansDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsVentureFundLoansDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundLoansDestroy(
    params: VentureFundsVentureFundLoansDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsVentureFundLoansDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundLoansPartialUpdate()` */
  static readonly VentureFundsVentureFundLoansPartialUpdatePath = '/api/venture_funds/venture-fund-loans/{id}/';

  /**
   * Частично обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundLoansPartialUpdate$Response(
    params: VentureFundsVentureFundLoansPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundLoansPartialUpdate(
    params: VentureFundsVentureFundLoansPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /**
   * Частично обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /**
   * Частично обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundLoansPartialUpdate$FormData$Response(
    params: VentureFundsVentureFundLoansPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить займ венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundLoansPartialUpdate$FormData(
    params: VentureFundsVentureFundLoansPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundLoansCopyCreate()` */
  static readonly VentureFundsVentureFundLoansCopyCreatePath = '/api/venture_funds/venture-fund-loans/{id}/copy/';

  /**
   * Скопировать займ венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundLoansCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundLoansCopyCreate$Response(
    params: VentureFundsVentureFundLoansCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
    return ventureFundsVentureFundLoansCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Скопировать займ венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundLoansCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundLoansCopyCreate(
    params: VentureFundsVentureFundLoansCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundLoanDto> {
    return this.ventureFundsVentureFundLoansCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundLoanDto>): BackendVentureFundLoanDto => r.body),
    );
  }
}
